// Skill levels are percentages (0-100).

export const skillGroups = [
    {
        name: 'Languages',
        skills: [
            { label: 'Python', value: 90 },
            { label: 'JS', value: 85 },
            { label: 'TS', value: 80 },
            { label: 'PHP', value: 75 },
            { label: 'CSS', value: 65 },
            { label: 'C++', value: 60 },
            { label: 'MT5', value: 60 },
            { label: 'Rust', value: 60 },
            { label: 'Java', value: 40 },
            { label: 'C#', value: 40 },
        ],
    },
    {
        name: 'Frameworks',
        skills: [
            { label: 'VueJS', value: 95 },
            { label: 'ReactJS', value: 90 },
            { label: 'Electron', value: 90 },
            { label: 'Laravel', value: 75 },
            { label: 'ExpressJS', value: 70 },
            { label: 'Flutter', value: 70 },
            { label: 'Django', value: 70 },
            { label: '.Net', value: 40 },
        ],
    },
    {
        name: 'Misc. Front-End',
        skills: [
            { label: 'Gsap', value: 80 },
            { label: 'WebGL', value: 75 },
            { label: 'SVG', value: 75 },
            { label: 'ThreeJS', value: 40 },
        ],
    },
    {
        name: 'ML/DL Modules',
        skills: [
            { label: 'Computer Vision', value: 95 },
            { label: 'TensorFlow', value: 95 },
            { label: 'Keras', value: 95 },
            { label: 'Torch', value: 95 },
            { label: 'Transformers', value: 95 },
            { label: 'Numpy', value: 95 },
            { label: 'Scikit-learn', value: 85 },
            { label: 'Pandas', value: 80 },
            { label: 'NLTK', value: 75 },
        ],
    },
    {
        name: 'Data Warehouse',
        skills: [
            { label: 'MySQL', value: 95 },
            { label: 'Firebase', value: 80 },
            { label: 'MongoDB', value: 40 },
        ],
    },
];

export const tools = [
    { name: 'Adobe After Effects', logo: '/img/adobe_after_effects_logo.svg' },
    { name: 'Adobe Animate', logo: '/img/adobe_animate_logo.svg' },
    { name: 'Adobe Illustrator', logo: '/img/adobe_illustrator_logo.svg' },
    { name: 'Adobe Photoshop', logo: '/img/adobe_photoshop_logo.svg' },
    { name: 'Adobe Premiere', logo: '/img/adobe_premiere_logo.svg' },
    { name: 'Adobe XD', logo: '/img/adobe_xd_logo.svg' },
    { name: 'Unity', logo: '/img/unity_technologies_logo.svg' },
    { name: 'Steinberg Cubase', logo: '/img/cubase_logo.svg' },
    { name: 'Bandlab Cakewalk', logo: '/img/bandlab_logo.svg' },
    { name: 'Ableton', logo: '/img/ableton_logo.svg' },
];

export const languages = [
    {
        name: 'Malagasy',
        skills: [
            { label: 'Listening', value: 95 },
            { label: 'Speaking', value: 95 },
            { label: 'Reading', value: 95 },
            { label: 'Writing', value: 80 },
        ],
    },
    {
        name: 'Français',
        skills: [
            { label: 'Listening', value: 95 },
            { label: 'Speaking', value: 90 },
            { label: 'Reading', value: 95 },
            { label: 'Writing', value: 95 },
        ],
    },
    {
        name: 'English',
        skills: [
            { label: 'Listening', value: 95 },
            { label: 'Speaking', value: 60 },
            { label: 'Reading', value: 95 },
            { label: 'Writing', value: 80 },
        ],
    },
];
